import { useQuery } from 'react-query';
import { bugSnagNotifyAPIError } from 'src/helper/bugSnagHelper';
import axiosNoInterceptor from 'src/services/axiosNoInterceptor';
import { ORDER_MICRO_SERIVCE } from 'src/constants';

const verifyPaymentLink = async (id: string) => {
  const response = await axiosNoInterceptor.get(`${ORDER_MICRO_SERIVCE}/verify-payment-link/${id}?is_catering=1`, {
    headers: {
      'Authorization': "token",
      'token': "token"
    }
  });
  return response.data.data;
};

export default function useVerifyPaymentLink(id: string) {
  return useQuery(id, () => verifyPaymentLink(id), {
    retry: false,
    enabled: Boolean(id),
    onError: (error: any) => {
      bugSnagNotifyAPIError("/add-payment", { ...error?.response }, error?.response?.data?.message)
    }
  });
}
